<template>
    <div class="vue-popup__wrap">
        <div class="vue-popup" v-on-click-outside.static="closePopup">
            <a class="vue-popup__close" href="javascript:;" @click="closePopup"></a>
            <div class="single-product__wrapper single-product__wrapper--single">
                <perfect-scrollbar class="ps-custom-select-popup" @ps-scroll-y="onScroll" ref="scrollbar">
                    <div class="container vue-popup__cont">
                        <div class="row vue-popup__row">
                            <div class="col-lg-6 col-md-12 offset-lg-6 single-product__container">
                                <div class="single-product__outer">
                                    <div class="single-product__inner">
                                        <div class="single-product__slider-wrapper js-single-product__slider-wrapper">
                                            <div class="slider-product__slider-img">
                                                <div class="slider-product__slider-img-wrap media-wrap--lazy-loader" ref="productImageWrapRef">
                                                    <img class="lazy" @load="onImageLoaded" :src="product.image ||
                                                        kadraGlobal.icons +
                                                        '/src/assets/images/plch.jpg'
                                                        " alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="single-product__info-wrapper">
                                    <div class="single-product__info">
                                        <!-- TODO: Add part - Add to list -->
                                        <div class="single-product__info-wrap">
                                            <span class="single-product__info-pretitle" v-html="getBrands()"></span>
                                            <a :href="kadraGlobal.Url + '/product/' + product.slug"
                                                class="single-product__info-link">Go to product</a>
                                        </div>
                                        <span class="single-product__info-title" v-html="product.title"></span>
                                    </div>
                                </div>
                                <div class="single-product__info-box-wrapper">
                                    <div class="single-product__info-box">
                                        <div class="single-product__info-box-accordions-wrapper">
                                            <div class="single-poduct__info-box-accordion">
                                                <div class="single-product__info-box-accordion-content">
                                                    <div class="single-product__info-box-accordion-content-half">
                                                        <span class="single-product__info-box-accordion-content-info"
                                                            v-if="product.pa_size && !product.pa_color">
                                                            Size
                                                            <strong>{{ getSizeName(product.pa_size) }}</strong>
                                                        </span>
                                                        <span class="single-product__info-box-accordion-content-info"
                                                            v-if="product.pa_color && !product.pa_size">
                                                            Color
                                                            <strong>{{ getColorName(product.pa_color) }}</strong>
                                                        </span>
                                                        <span class="single-product__info-box-accordion-content-info"
                                                            v-if="product.pa_color && product.pa_size">
                                                            Size And Color
                                                            <strong>
                                                                {{ getSizeName(product.pa_size) }} |
                                                                {{ getColorName(product.pa_color) }}
                                                            </strong>
                                                        </span>
                                                        <span class="single-product__info-box-accordion-content-info" v-if="product.upc
                                                            ">UPC
                                                            <strong>{{
                                                                product.upc
                                                            }}</strong>
                                                        </span>
                                                    </div>
                                                    <div class="single-product__info-box-accordion-content-half">
                                                        <span class="single-product__info-box-accordion-content-info">SKU
                                                            <strong>{{
                                                                product.sku
                                                            }}</strong></span>
                                                        <span class="single-product__info-box-accordion-content-info">case
                                                            pack
                                                            <strong>{{
                                                                product.pack
                                                            }}
                                                                UNIT</strong></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="product.description" class="single-poduct__info-box-accordion">
                                                Additional Details
                                                <div class="single-product__info-box-accordion-content" v-html="product.description
                                                    "></div>
                                            </div>
                                        </div>
                                        <div class="single-product__info-box-promo" v-if="product.acfFields">
                                            <span class="single-product__info-box-promo-text">{{
                                                product.acfFields
                                            }}</span>
                                        </div>
                                        <div class="single-product__info-box-total-wrapper" v-if="isLoggedUser">
                                            <div class="single-product__info-box-total-price-wrapper">
                                                <span class="single-product__info-box-total-price"><sup>$</sup>{{
                                                    product.price
                                                }}</span>
                                                <span class="single-product__info-box-total-price-unit">/unit</span>
                                            </div>
                                            <div class="single-product__info-box-total-price-quantity-wrap">
                                                <div class="single-product__info-box-total-price-quantity-out">
                                                    <span
                                                        class="single-product__info-box-total-price-quantity-out-icon"></span>
                                                    <span class="single-product__info-box-total-price-quantity-out-text">Out
                                                        of Stock</span>
                                                </div>
                                                <div class="single-product__info-box-total-price-quantity js-select-all"
                                                    v-if="userType !== 'salesman'
                                                            ">
                                                    <span
                                                        class="single-product__info-box-total-price-quantity-toggle single-product__info-box-total-price-quantity-toggle--minus"
                                                        @click="onQtyMinus"></span>
                                                    <input
                                                    type="text"
                                                    id="singleInputShow"
                                                    v-model="inputQty"
                                                    @input="onQtyKeyUp($event.target)"
                                                    @keyup="onQtyKeyUp($event.target)"
                                                    min="0"
                                                    maxlength="5"
                                                    placeholder="0"
                                                    @focus="handleFocus(product.id)"
                                                    @blur="handleBlur"/>
                                                    <span
                                                        class="single-product__info-box-total-price-quantity-toggle single-product__info-box-total-price-quantity-toggle--plus"
                                                        @click="onQtyPlus"></span>
                                                </div>
                                                <div class="single-product__info-box-total-price-quantity-loader" v-if="userType !== 'salesman'
                                                    ">
                                                    <!-- When Qty is 0 or empty -->
                                                    <span
                                                        class="product-info-box__total-cases js-single-case"
                                                        v-if="hideProcessing && (!inputQty || parseInt(inputQty) === 0)"
                                                    >
                                                        Units in cart
                                                    </span>

                                                    <!-- When Qty is 1 or more -->
                                                    <span
                                                        class="product-info-box__total-cases js-single-case product-info-box__total-cases--checked"
                                                        v-else-if="hideProcessing && parseInt(inputQty) > 0"
                                                    >
                                                        Units in cart
                                                    </span>

                                                    <!-- Processing Loader -->
                                                    <span
                                                        class="product-info-box__total-quantity-loader js-single-case-processing"
                                                        v-if="!hideProcessing"
                                                    >
                                                        Processing...
                                                    </span>
                                                </div>
                                                <div v-if="userType === 'salesman'
                                                    " class="salesman-notification-wrap">
                                                    <span class="salesman-notification">Please select a
                                                        customer.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <a href="javascript:" class="js-login-wrap single-product__info-box-login-wrap"
                                            v-if="!isLoggedUser" @click="
                                                openLoginPopup(product.id)
                                                ">
                                            <button class="addToCart loginPrice js-login-popup">
                                                LOGIN TO SEE PRICE
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ProductSlider></ProductSlider>
                </perfect-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import { mapState } from 'vuex';
import ProductSlider from '../../ProductSlider/index';

export default {
    components: {
        ProductSlider,
        PerfectScrollbar
    },

    mixins: [onClickOutside],

    props: ['productId', 'addToCartSingle'],

    data() {
        return {
            product: {},
            inputQty: '',
            kadraGlobal: kadraGlobal,
            userType: window.usingcustomer.session.type,
            isLoggedUser: kadraGlobal.userId > 0,
            cartUpdateTimeout: null,
            addToCart: false,
            hideProcessing: true,
            imageLoaded: false,
        };
    },

    computed: mapState({
        products: state => state.Listing.products,
        attributes: state => state.Listing.attributes,
        cart: state => state.Cart.cart
    }),

    methods: {
        onImageLoaded() {
            this.imageLoaded = true;
        },
        onScroll() {
            this.$refs.scrollbar.ps.update();
        },
        closePopup() {
            this.$emit('closePopup');
        },
        setProduct() {
            const searchId = this.productId;
            this.products.forEach(obj => {
                if (obj.id === searchId) {
                    // update global js variable
                    window.productId = searchId;
                    // set object
                    this.product = { ...obj };
                }
            });
            // update quantity model
            this.inputQty = this.getCartQty();
        },
        handleFocus(id) {
            this.focusedInput = id;
        },
        handleBlur() {
            if (!String(this.inputQty).trim()) {
                this.inputQty = '';// Reset to empty string if it's empty
            }
            this.focusedInput = null;
        },
        getCartQty() {
            /* return this.cart[this.productId] || 0; */
            return this.cart[this.productId] === 0 ? '' : (String(parseInt(this.cart[this.productId]) || ''));
        },
        getBrandName(id) {
            id = parseInt(id);
            return this.attributes.pa_brand.find(obj => obj.term_id === id).name;
        },
        getColorName(id) {
            id = parseInt(id);
            return this.attributes.pa_color.find(obj => obj.term_id === id).name;
        },
        getSizeName(id) {
            id = parseInt(id);
            return this.attributes.pa_size.find(obj => obj.term_id === id).name;
        },
        getBrands() {
            if (!this.product.pa_brand) {
                return '';
            }
            const names = [];
            this.product.pa_brand.split(',').forEach(id => {
                const name = this.getBrandName(parseInt(id));
                if (name) {
                    names.push(name);
                }
            });
            return names.join(', ');
        },
        onQtyMinus() {
            // sanitize model
            this.inputQty = Math.max(1, parseInt(this.inputQty) || 0) - 1;
            // dispatch
            this.delayedSendQty(
                this.product.id,
                this.product.pack,
                this.inputQty
            );
        },
        onQtyPlus() {
            // sanitize model
            this.inputQty = Math.max(0, parseInt(this.inputQty) || 0) + 1;
            // dispatch
            this.delayedSendQty(
                this.product.id,
                this.product.pack,
                this.inputQty
            );
        },
        onQtyKeyUp(e) {
            let val = e.value.replace(/[^0-9]/g, '');
            const max = e.maxLength;

            if (val.length >= max) {
                val = val.slice(0, max);
                /* this.inputQty = val; */
            }

            // Treat empty input as '0'
            if (val.trim() === '') {
                val = '0'; // Default to '0' when empty
            }

            // Update the inputQty model
            this.inputQty = String(val || '');
            // dispatch
            this.delayedSendQty(
                this.product.id,
                this.product.pack,
                this.inputQty
            );
        },
        delayedSendQty(Id, Pack, Qty) {
            clearTimeout(this.cartUpdateTimeout);
            this.addToCart = true;
            this.hideProcessing = false;
            this.cartUpdateTimeout = setTimeout(() => {
                console.log('ProductPopupDetail.delayedSendQty', Id, Qty);
                this.$store.dispatch('addMany', {
                    id: Id,
                    val: Qty,
                    pack: Pack
                });
                this.addToCart = false;
                this.hideProcessing = true;
            }, 500);
        },
        openLoginPopup(ele) {
            const popup = document.getElementsByClassName(
                'js-popup-login-form'
            );
            popup[0].classList.add('active');
            popup[0].setAttribute('data-id', ele);
        }
    },

    watch: {
        products() {
            this.setProduct();
        },

        imageLoaded() {
            if(this.imageLoaded) {
                this.$refs.productImageWrapRef.classList.remove('media-wrap--lazy-loader');
            }
        }
    },

    beforeMount() {
        // initialize this.product
        this.setProduct();
    },

    mounted() {
        document.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                this.closePopup();
            }
        });
    },

    created() {
        // slider use these global js variables
        window.sliderTermIds = [];
        window.productId = 0;
    }
};
</script>

<style lang="scss" scoped>
.single-product__wrapper {
    z-index: 4;
    overflow: hidden;
    max-width: 100%;
    width: 100%;
    position: relative;
    width: 100%;
    height: 100%;
}

.single-product__slider-wrapper {
    opacity: 1;
}

.single-product__outer {
    @include mq($lg) {
        padding-top: 0;
        padding-bottom: 0;
        margin: 10px 0;
    }
}

.single-product__info-box-wrapper {
    @include mq($lg) {
        padding-top: 0;
    }
}

.single-product__info-box-accordions-wrapper {
    @include mq($lg) {
        padding: 10px 20px;
    }
}

.single-poduct__info-box-accordion {
    @include mq($lg) {
        margin-top: 0;
    }
}

.logged-in .slider-product__slider-img {
    @include mq($lg) {
        height: 270px;
    }
}

.single-product__info-box-accordion-content-info {
    @include mq($sm) {
        width: 100%;
    }
}

.single-product__info-link {
    font-family: $font-main;
    font-size: 14px;
    color: $theme-green;
    display: inline-block;
    position: relative;
    cursor: pointer;
    padding-right: 15px;
    transition: $dur $ease;
    margin-bottom: 15px;

    @include mq(513px) {
        margin-bottom: 5px;
    }

    &:hover {
        &::after {
            width: 100%;
            opacity: 1;
            transition: $dur $ease;
        }
    }

    &::before {
        content: url('data:image/svg+xml;charset=UTF-8, <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="svg-inline--fa fa-long-arrow-alt-right fa-w-14" data-icon="long-arrow-alt-right" data-prefix="fas" viewBox="0 0 448 512" fill="rgb(0, 190, 157)"><path d="M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"/></svg>');
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        color: $theme-green;
        font-size: 12px;
        height: 10px;
        width: 10px;
    }

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: $theme-green;
        width: 0;
        opacity: 0;
        height: 1px;
    }
}

.single-product__info-title {
    display: block;
}

.single-product__info-box-login-wrap {
    button {
        margin-top: 0 !important;
        margin-bottom: 15px;
    }
}

.single-product__info-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include mq(513px) {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
}

.vue-popup__cont {
    max-width: 100%;
    padding: 0;

    @include mq($lg) {
        max-width: 100%;
    }

    @include mq($md) {
        max-width: 100%;
    }
}

.vue-popup__row {
    margin: 0;
}

.single-product__container {
    @include mq($md) {
        padding: 0;
    }
}

.slider-product__slider-img-wrap.media-wrap--lazy-loader {
    position: relative;
    overflow: hidden;
}

#singleInputShow {
    &::placeholder {
        color: $white;
    }

    &:focus {
        &::placeholder {
            color: transparent !important;
        }
    }
}

.product-info-box__total-cases--checked {
    position: relative;
    padding-left: 14px;

    &::after {
        content: '';
        position: absolute;
        left: -4px;
        top: 1px;
        display: inline-block;
        transform: rotate(45deg);
        height: 11px;
        width: 8px;
        border-bottom: 2px solid #00be9d;
        border-right: 2px solid #00be9d;
        transition: 200ms ease-in-out;
    }
}
</style>
